import { useAppSelector } from 'hooks/useAppSelector';
import { Underlying, UnderlyingAssetType } from 'models/underlying';
import { useCallback, useMemo } from 'react';
import { getUserPreferencesUnderlyingCodeType } from 'state/selectors';
import { generateAllUnderlyingsExcelGrid } from 'utils/underlying/export-underlyings-to-excel';

export function useGenerateUnderlyingsGridForExcel(underlyings: readonly Underlying[]) {
  const defaultUnderlyingCodeType = useAppSelector(getUserPreferencesUnderlyingCodeType);

  const underlyingsGroupedByAssetType = useMemo(() => {
    return underlyings.reduce((map, underlying) => {
      const assetUnderlyings = map.get(underlying.asset) || [];

      map.set(underlying.asset, [...assetUnderlyings, underlying]);

      return map;
    }, new Map<UnderlyingAssetType, Underlying[]>());
  }, [underlyings]);

  const generateTableExport = useCallback(() => {
    const codeType = defaultUnderlyingCodeType === 'Reuters' ? 'Reuters' : 'Bloomberg';
    return generateAllUnderlyingsExcelGrid(codeType)(underlyingsGroupedByAssetType);
  }, [underlyingsGroupedByAssetType, defaultUnderlyingCodeType]);

  return { underlyingsGroupedByAssetType, generateTableExport };
}
